import React, { useEffect, useRef, useState } from 'react';
interface EditableNumberProps {
  value: number;
  onChange: (next: number) => void;
  min: number;
  max: number;
  label: string;
  prefix?: string;
  className?: string;
}
export function EditableNumber({
  value,
  onChange,
  min,
  max,
  label,
  prefix = '',
  className = ''
}: EditableNumberProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(String(value));
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [isEditing]);
  const commit = () => {
    const parsed = Number(draft.replace(/[^0-9]/g, ''));
    if (Number.isFinite(parsed) && parsed > 0) {
      onChange(Math.min(max, Math.max(min, parsed)));
    }
    setIsEditing(false);
  };
  if (isEditing) {
    return <span className="inline-flex items-baseline" data-id="element-192" data-mp="325fa83pz09zi">
        {prefix && <span className={className} data-id="element-193" data-mp="323kpoqim2jvy">{prefix}</span>}
        <input ref={inputRef} type="text" inputMode="numeric" value={draft} aria-label={label} onChange={event => setDraft(event.target.value)} onBlur={commit} onKeyDown={event => {
        if (event.key === 'Enter') {
          commit();
        }
        if (event.key === 'Escape') {
          setDraft(String(value));
          setIsEditing(false);
        }
      }} className={`w-[4.5ch] bg-transparent border-b border-[#7FE0C3] text-center outline-none ${className}`} data-id="element-194" data-mp="3s9vy1ze893gw" />
      </span>;
  }
  return <button type="button" onClick={() => {
    setDraft(String(value));
    setIsEditing(true);
  }} aria-label={`${label}. Click to edit.`} className={`border-b border-dashed border-[#7FE0C3]/40 hover:border-[#7FE0C3] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FE0C3] ${className}`} data-id="element-195" data-mp="2zl75ior8m6gr">
      {prefix}
      {value.toLocaleString('en-US')}
    </button>;
}